import { useMutation } from "@tanstack/react-query";
import { API_PAYMENT } from "../apis";

export const usePostBookingConfirm = () => {
    const { mutate, isSuccess, error } = useMutation<any, Error, any>({
        mutationFn: (formData) => API_PAYMENT.postPaymentBookingConfirm(formData),
        mutationKey: ["POST_BOOKING_CONFIRM"],
        onError: () => {
            alert("통신 장애 발생");
        },
    });

    return { mutate, isSuccess, error };
};

export const usePostBookingConfirmTest = () => {
    const { mutate, isSuccess, error } = useMutation<any, Error, any>({
        mutationFn: (formData) => API_PAYMENT.postPaymentBookingConfirmTest(formData),
        mutationKey: ["POST_BOOKING_CONFIRM"],
        onError: () => {
            alert("통신 장애 발생");
        },
    });

    return { mutate, isSuccess, error };
};
